function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Message({
  width = 31,
  height = 31,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M24.634 24.312c-3.948 3.82-9.793 4.645-14.576 2.505-.707-.276-1.285-.498-1.836-.498-1.533.009-3.441 1.447-4.433.489-.992-.96.496-2.808.496-4.3 0-.533-.22-1.083-.505-1.767-2.213-4.628-1.36-10.286 2.588-14.105 5.04-4.878 13.227-4.878 18.266-.001 5.048 4.885 5.04 12.8 0 17.677z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M20.589 15.992h.011M15.41 15.992h.012M10.232 15.992h.011",
    stroke: "#130F26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
//# sourceMappingURL=Message.js.map